import { render, staticRenderFns } from "./index.vue?vue&type=template&id=77d32abe&lang=html&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/erp-flexible-web21_zo1Z/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77d32abe')) {
      api.createRecord('77d32abe', component.options)
    } else {
      api.reload('77d32abe', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=77d32abe&lang=html&", function () {
      api.rerender('77d32abe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VueQuillEditor/div/index.vue"
export default component.exports